<div class="content-container">
    <div class="flex-container">
        <mat-form-field appearance="outline" class="form-field">
            <mat-label>Usable width</mat-label>
            <input matInput type="number" min="0" max="6000" step="1" [ngModel]="gangwayDoor.usableWidth"
                (ngModelChange)="gangwayDoor.usableWidth = $event" autocomplete="off">
        </mat-form-field>
        <mat-form-field class="form-field" *ngIf="show">
            <mat-label>Door wing type</mat-label>
            <mat-select [value]="door.doorWingType" (selectionChange)="changeDoorWingType($event.value)">
                <mat-option class="select-without-checkbox" *ngFor="let doorWingType of doorWingTypes"
                    [value]="doorWingType.ID">
                    {{doorWingType.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="form-field">
            <mat-label>Door opening type</mat-label>
            <mat-select [value]="gangwayDoor.doorOpeningType" (selectionChange)="changeDoorOpeningType($event.value)">
                <mat-option class="select-without-checkbox" *ngFor="let doorOpeningType of doorOpeningTypes"
                    [value]="doorOpeningType.ID">
                    {{doorOpeningType.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>